module.exports = "/src/views/player/help/images/ems.jpg";